import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import sanitizeHtml from 'sanitize-html';

const defaultAllowedTags = ['b', 'i', 'strong', 'p', 'a', 'ul', 'li', 'br'];
const defaultAllowedAttributes = {
  a: ['href', 'target', 'id'],
};

const SafeHTML = ({
  id = '',
  html = '',
  className = '',
  allowedTags = defaultAllowedTags,
  allowedAttributes = defaultAllowedAttributes,
  allowedStyles = undefined,
}) => {
  const safeHTML = useMemo(() => {
    const htmlWithBreaks = html
      ?.replace(/\n{1,}/g, '<br /><br />')
      ?.replace(/\n/g, ' ');

    return sanitizeHtml(htmlWithBreaks, {
      allowedTags,
      allowedAttributes,
      ...(allowedStyles ? { allowedStyles } : {}),
    });
  }, [html, allowedTags, allowedAttributes, allowedStyles]);

  return (
    <div
      id={id}
      className={className}
      dangerouslySetInnerHTML={{ __html: safeHTML }}
    />
  );
};

SafeHTML.propTypes = {
  id: PropTypes.string,
  html: PropTypes.string.isRequired,
  className: PropTypes.string,
  allowedTags: PropTypes.arrayOf(PropTypes.string),
  allowedAttributes: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.string)),
  // eslint-disable-next-line react/forbid-prop-types
  allowedStyles: PropTypes.object,
};

SafeHTML.defaultProps = {
  id: '',
  className: '',
  allowedTags: defaultAllowedTags,
  allowedAttributes: defaultAllowedAttributes,
  allowedStyles: undefined,
};

export default SafeHTML;
